import { PrintDataEntitas } from "@/domain/entities/Booking";
import jsPDF from "jspdf";
import { startCase } from "lodash";
import moment from "moment";

const resolveUrsaCode = (data: PrintDataEntitas) =>
  data.sttOperationArea || data.sttDistrictUrsaCode || "";

const resolveEstimateDate = (data: PrintDataEntitas) => {
  const parsed = new Date(data.estimateSla);
  const isValidDate = !isNaN(parsed.getTime());
  return isValidDate ? data.estimateSla : data.estimateSlaMaxDate;
};

const checkIsInterpack = (data: PrintDataEntitas): boolean => {
  return data.sttProductType.toLowerCase() === "interpack";
};

const getEstimateYPos = (data: PrintDataEntitas): number => {
  return data.sttProductType.toLowerCase() === "interpack" ? 45 : 46;
};

export const ursaSlaV3 = (
  params: {
    doc: jsPDF | any;
    startX: number;
    startY: number;
    data: PrintDataEntitas;
  },
  coor: {
    startX: number;
    startY: number;
  },
  translate: any
) => {
  const xShift = -2;
  const ursaCode = resolveUrsaCode(params.data);

  const isNewUrsaCode = params.data.sttOperationArea !== params.data.sttDistrictUrsaCode;
  params.doc.setFont("Inter", "extrabold");
  params.doc.setFontSize(isNewUrsaCode || String(ursaCode || "").length > 4 ? 12 : 20);
  params.doc.text(ursaCode, coor.startX + 78 + xShift, coor.startY + 27);

  params.doc.setTextColor("#333333");
  params.doc.setFont("Inter", "bold");
  params.doc.setFontSize(6);
  params.doc.text(
    `${startCase(translate("receipt.createdAtV2"))}:`,
    coor.startX + 78 + xShift,
    coor.startY + 31
  );

  const createdAt = moment(params.data.sttCreatedAt);
  const createdDay = createdAt.format("DD");
  const createdMonthYear = `/${createdAt.format("MM/YYYY")}`;

  params.doc.setFillColor("#333333");
  params.doc.setDrawColor("#333333");
  params.doc.rect(coor.startX + 77 + xShift, coor.startY + 32, 14, 10, "FD");

  params.doc.setTextColor("#FFFFFF");
  params.doc.setFont("Roboto Mono", "bold");
  params.doc.setFontSize(28);
  params.doc.text(createdDay, coor.startX + 84 + xShift, coor.startY + 40.5, { align: "center" });

  params.doc.setTextColor("#333333");
  params.doc.setFont("Roboto Mono", "bold");
  params.doc.setFontSize(6);
  params.doc.text(createdMonthYear, coor.startX + 91 + xShift, coor.startY + 38);

  const estimateDate = resolveEstimateDate(params.data);
  const estimateYPos = getEstimateYPos(params.data);
  params.doc.setFont("Inter", "bold");
  params.doc.setFontSize(6);
  params.doc.text(
    `${startCase(translate("receipt.estimation"))}:`,
    coor.startX + 78 + xShift,
    coor.startY + estimateYPos
  );
  params.doc.setFont("Roboto Mono", "bold");
  params.doc.setFontSize(6);
  params.doc.text(
    moment(estimateDate).format("DD/MM/YYYY"),
    coor.startX + 88 + xShift,
    coor.startY + estimateYPos
  );
  if (checkIsInterpack(params.data)) {
    params.doc.setFont("Inter", "medium");
    params.doc.setFontSize(5);
    params.doc.text(
      `${translate("receipt.customSla")}`,
      coor.startX + 78 + xShift,
      coor.startY + 47
    );
  }
};
